
// GET the language
export const LANGUAGE = localStorage.getItem("lang") || window.navigator.language.slice(0, 2);


// last_locat name to set on localstorage
export const NAME_LAST_LOC = "last_locat";


// token auth on localStorage
export const AUTH_TOKEN = localStorage.getItem("token");



// token auth name on localStorage
export const AUTH_TOKEN_NAME = "token";


// get the tour token
export const TOUR_TOKEN = localStorage.getItem("tour_activ");